// import React, { useEffect, useState } from 'react';
// import {
//   Grid,
//   Box,
//   Card,
//   Typography,
//   TextField,
//   Button,
//   CardContent,
//   Divider,
//   IconButton,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Chip,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   OutlinedInput,
//   SelectChangeEvent,
//   useMediaQuery,
//   CardActionArea,
//   Snackbar,
//   Alert,
//   Stepper,
//   Step,
//   StepLabel,
//   StepContent,
//   Paper
// } from '@mui/material';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
// import { useTheme } from '@mui/material/styles';
// import MainCard from 'ui-component/cards/MainCard';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { useDispatch, useSelector } from 'react-redux';
// import { useForm, Controller } from 'react-hook-form';
// import { useLocation } from 'react-router-dom';
// import {
//   fetchShiftNotes,
//   addShiftNote,
//   updateShiftNote,
//   removeShiftNote,
//   fetchCompletedShifts
// } from '../../../slices/NdisSlices/shiftDetails/shiftNotesSlice';
// import { RootState } from 'store';
// import { useAppSelector } from 'app/hooks';
// import {
//   ShiftNote,
//   ShiftNotesRequestBody,
//   AddShiftNoteRequest,
//   FormData,
//   CompletedShift
// } from '../../../types/ndisSection/shiftNotesTypes';
// import { useClientContext } from '../ProfileMainPage';
// import dayjs from 'dayjs';
// import * as Yup from 'yup';
// import { yupResolver } from '@hookform/resolvers/yup';

// // Options for form fields
// const personalCareOptions = [
//   'Bath',
//   'Continence Care',
//   'Dressing',
//   'None',
//   'Oral Hygiene',
//   'Other',
//   'Shower'
// ];
// const moodOptions = ['Fair', 'Good', 'Poor'];
// const ratingOptions = ['Critical', 'Important', 'FYI'];
// const securityLevelOptions = ['Low', 'Medium', 'High'];
// const medicationOptions = ['Yes', 'No', 'Other'];
// const foodIntakeOptions = ['Yes', 'No'];

// const steps = [
//   'Shift Selection',
//   'Basic Information',
//   'Care Details',
//   'Additional Information',
//   'Review & Submit'
// ];

// // Yup validation schema
// const validationSchema = Yup.object().shape({
//   clientName: Yup.string(),
//   title: Yup.string()
//     .required('Title is required')
//     .max(100, 'Title must be 100 characters or less'),
//   caseNoteDate: Yup.string().required('Date is required'),
//   caseNoteTime: Yup.string().required('Time is required'),
//   assignToStaff: Yup.array()
//     .of(Yup.string())
//     .min(1, 'At least one staff member must be assigned')
//     .required('At least one staff member must be assigned'),
//   medicationReceived: Yup.string().required('Medication status is required'),
//   foodProvided: Yup.string().max(200, 'Food Provided must be 200 characters or less'),
//   personalCare: Yup.string().required('Personal Care selection is required'),
//   foodIntakeChartCompleted: Yup.string(),
//   participantMood: Yup.string().required('Mood selection is required'),
//   goalsMet: Yup.string().max(500, 'Goals Met must be 500 characters or less'),
//   caseNoteDetails: Yup.string()
//     .required('Details are required')
//     .max(2000, 'Details must be 2000 characters or less'),
//   timeTaken: Yup.number()
//     .min(0, 'Time cannot be negative')
//     .max(1440, 'Time cannot exceed 24 hours'),
//   rating: Yup.string().required('Rating is required'),
//   securityLevel: Yup.string().required('Security Level is required'),
//   supportItemNumber: Yup.string(),
//   createdBy: Yup.string()
// }) as Yup.ObjectSchema<FormData>;

// const ShiftNotes: React.FC = () => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const { selectedClient } = useClientContext();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const [activeStep, setActiveStep] = useState(0);

//   // Redux state
//   const { shiftNotes, loading, error, completedShifts } = useSelector(
//     (state: RootState) => state.shiftNotes
//   );
//   const [editingNote, setEditingNote] = useState<ShiftNote | null>(null);
//   const [openDialog, setOpenDialog] = useState<boolean>(false);
//   const [selectedDate, setSelectedDate] = useState<string>(dayjs().format('YYYY-MM-DD'));
//   const [staffMembers, setStaffMembers] = useState<string[]>([]);
//   const [selectedShift, setSelectedShift] = useState<CompletedShift | null>(null);
//   const [toast, setToast] = useState<{
//     open: boolean;
//     message: string;
//     severity: 'error' | 'success' | 'info';
//   }>({
//     open: false,
//     message: '',
//     severity: 'error'
//   });

//   // App state
//   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
//   const selectedServiceTitle = useAppSelector(
//     (state) => state.serviceSelected.selectedServiceTitle
//   );
//   const userDetails = localStorage.getItem('user-details');
//   const loggedInWorkerName = userDetails ? JSON.parse(userDetails)?.name || '' : '';
//   const location = useLocation();
//   const componentParentId = location.pathname;

//   // React Hook Form with Yup validation
//   const {
//     control,
//     handleSubmit,
//     reset,
//     watch,
//     setValue,
//     formState: { errors },
//     trigger
//   } = useForm<FormData>({
//     defaultValues: {
//       clientName: selectedClient?.label || '',
//       title: '',
//       caseNoteDate: selectedShift?.shiftDate || dayjs().format('YYYY-MM-DD'),
//       caseNoteTime: dayjs().format('HH:mm A'),
//       assignToStaff: [],
//       medicationReceived: '',
//       foodProvided: '',
//       personalCare: '',
//       foodIntakeChartCompleted: '',
//       participantMood: '',
//       goalsMet: '',
//       caseNoteDetails: '',
//       timeTaken: 0,
//       rating: '',
//       securityLevel: '',
//       supportItemNumber: '',
//       createdBy: loggedInWorkerName
//     },
//     resolver: yupResolver(validationSchema),
//     mode: 'onChange'
//   });

//   // Watch for selectedShift changes to update form fields
//   useEffect(() => {
//     if (selectedShift) {
//       setValue('caseNoteDate', selectedShift.shiftDate, { shouldValidate: true });
//       setValue('caseNoteTime', selectedShift.shiftStartTime, { shouldValidate: true });
//       setValue('title', selectedShift.title || '', { shouldValidate: true });
//       setValue('assignToStaff', [selectedShift.user, selectedShift.manager].filter(Boolean), {
//         shouldValidate: true
//       });
//       setValue('clientName', selectedClient?.label || '', { shouldValidate: true });
//       setValue('caseNoteDetails', selectedShift.description || '', { shouldValidate: true });
//       setValue('supportItemNumber', selectedShift.supportItemNumber || '', {
//         shouldValidate: true
//       });
//       setValue('createdBy', selectedShift.createdBy || loggedInWorkerName, {
//         shouldValidate: true
//       });
//     }
//   }, [selectedShift, setValue, selectedClient]);

//   // Fetch staff members
//   useEffect(() => {
//     setStaffMembers(['worker1', 'worker2', 'manager2', 'Staff 3', 'Staff 4']);
//   }, []);

//   // Fetch completed shifts
//   useEffect(() => {
//     const reqBody = {
//       group_id: selectedProjectId || '',
//       service_name_id: selectedServiceTitle || '',
//       component_parent_id: componentParentId,
//       nested_component_id: 'Shift-notes',
//       user_whoRequested_id: selectedClient?.label || '',
//       client_name: selectedClient?.label || '',
//       shift_date: selectedDate
//     };
//     dispatch(fetchCompletedShifts(reqBody));
//   }, [
//     dispatch,
//     selectedDate,
//     selectedProjectId,
//     selectedServiceTitle,
//     componentParentId,
//     selectedClient
//   ]);

//   // Fetch shift notes
//   useEffect(() => {
//     const reqBody: ShiftNotesRequestBody = {
//       group_id: selectedProjectId || '',
//       service_name_id: selectedServiceTitle || '',
//       component_parent_id: componentParentId,
//       nested_component_id: 'Shift-notes',
//       user_whoRequested_id: selectedClient?.label || '',
//       shift_date: selectedDate
//     };
//     dispatch(fetchShiftNotes(reqBody));
//   }, [
//     dispatch,
//     selectedDate,
//     selectedProjectId,
//     selectedServiceTitle,
//     componentParentId,
//     selectedClient
//   ]);

//   // Debug logging for shiftNotes and completedShifts
//   useEffect(() => {
//     console.log('Current shiftNotes:', shiftNotes);
//     console.log('Current completedShifts:', completedShifts);
//   }, [shiftNotes, completedShifts]);

//   // Define fields to validate for each step
//   const stepFields: { [key: number]: (keyof FormData)[] } = {
//     0: [], // Shift Selection (no form fields, only selectedShift check)
//     1: ['title', 'caseNoteDate', 'caseNoteTime', 'assignToStaff'], // Basic Information
//     2: ['medicationReceived', 'personalCare'], // Care Details
//     3: ['participantMood', 'caseNoteDetails', 'rating', 'securityLevel'], // Additional Information
//     4: [] // Review & Submit (no additional validation needed)
//   };

//   // Handlers
//   const handleNext = async () => {
//     if (activeStep === 0) {
//       if (!selectedShift) {
//         setToast({
//           open: true,
//           message: 'Please select a completed shift',
//           severity: 'error'
//         });
//         return;
//       }
//       setActiveStep((prev) => prev + 1);
//       return;
//     }

//     // Trigger validation for the fields in the current step
//     const fieldsToValidate = stepFields[activeStep];
//     const isValid = await trigger(fieldsToValidate);

//     if (!isValid) {
//       // Collect error messages for the fields in the current step
//       const errorMessages = fieldsToValidate
//         .map((field) => errors[field]?.message)
//         .filter(Boolean)
//         .join(', ');

//       setToast({
//         open: true,
//         message: `Please correct the following errors: ${
//           errorMessages || 'Required fields are missing'
//         }`,
//         severity: 'error'
//       });
//       return;
//     }

//     setActiveStep((prevActiveStep) => prevActiveStep + 1);
//   };

//   const handleBack = () => {
//     setActiveStep((prevActiveStep) => prevActiveStep - 1);
//   };

//   const handleEdit = (note: ShiftNote) => {
//     setEditingNote(note);
//     setOpenDialog(true);
//   };

//   const handleDelete = (shiftNote: ShiftNote) => {
//     const reqBody = {
//       group_id: selectedProjectId || '',
//       service_name_id: selectedServiceTitle || '',
//       component_parent_id: componentParentId,
//       nested_component_id: 'Shift-notes',
//       user_whoRequested_id: selectedClient?.label || '',
//       event_id: shiftNote.shift_id,
//       shift_date: selectedDate
//     };
//     dispatch(removeShiftNote(reqBody));
//     setToast({
//       open: true,
//       message: 'Shift note deleted successfully',
//       severity: 'success'
//     });
//     const fetchReqBody: ShiftNotesRequestBody = {
//       group_id: selectedProjectId || '',
//       service_name_id: selectedServiceTitle || '',
//       component_parent_id: componentParentId,
//       nested_component_id: 'Shift-notes',
//       user_whoRequested_id: selectedClient?.label || '',
//       shift_date: selectedDate
//     };
//     setTimeout(() => {
//       dispatch(fetchShiftNotes(fetchReqBody));
//     }, 500);
//   };

//   const handleDialogClose = () => {
//     setOpenDialog(false);
//     setEditingNote(null);
//   };

//   const handleDialogSave = () => {
//     if (editingNote) {
//       const updatedNotes = shiftNotes.map((note) =>
//         note.shift_id === editingNote.shift_id ? editingNote : note
//       );
//       dispatch({
//         type: 'shiftNotes/updateShiftNoteSuccess',
//         payload: editingNote
//       });
//       dispatch(updateShiftNote(editingNote as AddShiftNoteRequest));
//       setToast({
//         open: true,
//         message: 'Shift note updated successfully',
//         severity: 'success'
//       });
//       handleDialogClose();
//       const fetchReqBody: ShiftNotesRequestBody = {
//         group_id: selectedProjectId || '',
//         service_name_id: selectedServiceTitle || '',
//         component_parent_id: componentParentId,
//         nested_component_id: 'Shift-notes',
//         user_whoRequested_id: selectedClient?.label || '',
//         shift_date: selectedDate
//       };
//       setTimeout(() => {
//         dispatch(fetchShiftNotes(fetchReqBody));
//       }, 500);
//     }
//   };

//   const handleShiftSelect = (shift: CompletedShift) => {
//     setSelectedShift(shift);
//   };

//   const handleToastClose = () => {
//     setToast({ ...toast, open: false });
//   };

//   const onSubmit = (values: FormData) => {
//     if (!selectedShift) {
//       setToast({
//         open: true,
//         message: 'Please select a completed shift',
//         severity: 'error'
//       });
//       return;
//     }

//     const newShiftNote: AddShiftNoteRequest = {
//       group_id: selectedProjectId || '',
//       service_name_id: selectedServiceTitle || '',
//       component_parent_id: componentParentId,
//       nested_component_id: 'Shift-notes',
//       user_whoRequested_id: selectedClient?.label || '',
//       shift_id: selectedShift.id,
//       worker_name: selectedShift.user,
//       shift_date: selectedShift.shiftDate,
//       shift_time: values.caseNoteTime,
//       shift_details: values.caseNoteDetails,
//       status: 'New',
//       shift_date_filter: selectedDate,
//       clientName: values.clientName,
//       title: values.title,
//       caseNoteDate: values.caseNoteDate,
//       caseNoteTime: values.caseNoteTime,
//       assignToStaff: values.assignToStaff,
//       medicationReceived: values.medicationReceived,
//       foodProvided: values.foodProvided,
//       personalCare: values.personalCare,
//       foodIntakeChartCompleted: values.foodIntakeChartCompleted,
//       participantMood: values.participantMood,
//       goalsMet: values.goalsMet,
//       caseNoteDetails: values.caseNoteDetails,
//       timeTaken: values.timeTaken,
//       rating: values.rating,
//       securityLevel: values.securityLevel,
//       shiftStartTime: selectedShift.shiftStartTime,
//       shiftEndTime: selectedShift.shiftEndTime,
//       supportItemNumber: values.supportItemNumber,
//       createdBy: values.createdBy || loggedInWorkerName
//     };

//     dispatch({
//       type: 'shiftNotes/addShiftNoteSuccess',
//       payload: newShiftNote
//     });
//     dispatch(addShiftNote(newShiftNote));
//     setToast({
//       open: true,
//       message: 'Shift note added successfully',
//       severity: 'success'
//     });
//     reset();
//     setSelectedShift(null);
//     setActiveStep(0);
//     const fetchReqBody: ShiftNotesRequestBody = {
//       group_id: selectedProjectId || '',
//       service_name_id: selectedServiceTitle || '',
//       component_parent_id: componentParentId || '',
//       nested_component_id: 'Shift-notes',
//       user_whoRequested_id: selectedClient?.label || '',
//       shift_date: selectedDate
//     };
//     setTimeout(() => {
//       dispatch(fetchShiftNotes(fetchReqBody));
//     }, 500);
//   };

//   return (
//     <Box sx={{ width: '100%', m: 1 }}>
//       <Snackbar
//         open={toast.open}
//         autoHideDuration={3000}
//         onClose={handleToastClose}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert onClose={handleToastClose} severity={toast.severity} sx={{ width: '100%' }}>
//           {toast.message}
//         </Alert>
//       </Snackbar>

//       <MainCard
//         title="Completed Shifts"
//         sx={{
//           p: isMobile ? 0.5 : 1,
//           '& .MuiCardHeader-root': { p: 0.5 },
//           '& .MuiCardContent-root': { p: isMobile ? 0.5 : 1 }
//         }}
//       >
//         {loading ? (
//           <Typography>Loading...</Typography>
//         ) : error ? (
//           <Typography color="error">No completed shifts found</Typography>
//         ) : completedShifts.length > 0 ? (
//           <Box
//             sx={{
//               display: 'flex',
//               overflowX: 'auto',
//               gap: 1.5,
//               py: 0.5,
//               scrollbarWidth: 'thin',
//               '&::-webkit-scrollbar': {
//                 height: '6px'
//               },
//               '&::-webkit-scrollbar-thumb': {
//                 backgroundColor: theme.palette.grey[400],
//                 borderRadius: '3px'
//               }
//             }}
//           >
//             {completedShifts.map((shift) => (
//               <Card
//                 key={shift.id}
//                 sx={{
//                   minWidth: isMobile ? 160 : 180,
//                   width: isMobile ? 160 : 180,
//                   border:
//                     selectedShift?.id === shift.id
//                       ? `2px solid ${theme.palette.primary.main}`
//                       : '1px solid rgba(0, 0, 0, 0.12)',
//                   boxShadow:
//                     selectedShift?.id === shift.id
//                       ? `0 0 8px ${theme.palette.primary.light}`
//                       : '0 2px 4px rgba(0,0,0,0.1)',
//                   transition: 'all 0.2s',
//                   '&:hover': {
//                     boxShadow: `0 4px 8px rgba(0,0,0,0.15)`,
//                     cursor: 'pointer',
//                     transform: 'translateY(-2px)'
//                   },
//                   flexShrink: 0,
//                   borderRadius: 2,
//                   display: 'flex',
//                   flexDirection: 'column'
//                 }}
//               >
//                 <CardActionArea onClick={() => handleShiftSelect(shift)} sx={{ flexGrow: 1 }}>
//                   <CardContent sx={{ p: 1 }}>
//                     <Box
//                       display="flex"
//                       justifyContent="space-between"
//                       alignItems="flex-start"
//                       mb={0.5}
//                     >
//                       <Typography
//                         variant="subtitle2"
//                         fontWeight="bold"
//                         noWrap
//                         sx={{
//                           maxWidth: 100,
//                           textOverflow: 'ellipsis',
//                           overflow: 'hidden'
//                         }}
//                       >
//                         {shift.user}
//                       </Typography>
//                       <Chip
//                         label={shift.status}
//                         variant="outlined"
//                         color="success"
//                         size="small"
//                         sx={{
//                           height: 20,
//                           fontSize: '0.675rem',
//                           fontWeight: 500,
//                           borderRadius: '6px',
//                           borderColor: 'success.main',
//                           color: 'success.dark',
//                           backgroundColor: '#e6f4ea',
//                           '& .MuiChip-label': {
//                             px: 1,
//                             py: 0.25
//                           }
//                         }}
//                       />
//                     </Box>
//                     <Box
//                       sx={{
//                         backgroundColor: theme.palette.grey[100],
//                         borderRadius: 1,
//                         p: 0.5,
//                         mb: 0.5
//                       }}
//                     >
//                       <Typography variant="caption" fontWeight="bold" display="block">
//                         {dayjs(shift.shiftDate).format('DD MMM')}
//                       </Typography>
//                       <Typography variant="caption" display="block" color="text.secondary">
//                         {shift.shiftStartTime} - {shift.shiftEndTime}
//                       </Typography>
//                     </Box>
//                     <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                       <Typography variant="caption" fontWeight="bold">
//                         Total:
//                       </Typography>
//                       <Typography variant="caption">{shift.totalTime}</Typography>
//                     </Box>
//                     <Box
//                       sx={{
//                         backgroundColor: theme.palette.primary.light,
//                         borderRadius: 1,
//                         p: 0.5,
//                         textAlign: 'center'
//                       }}
//                     >
//                       <Typography variant="caption" fontWeight="bold">
//                         #{shift.title}
//                       </Typography>
//                     </Box>
//                   </CardContent>
//                 </CardActionArea>
//               </Card>
//             ))}
//           </Box>
//         ) : (
//           <Typography variant="body2" color="text.secondary">
//             No completed shifts available
//           </Typography>
//         )}
//       </MainCard>

//       <form onSubmit={handleSubmit(onSubmit)}>
//         <Grid container spacing={1} sx={{ width: '100%' }}>
//           <Grid item xs={12} md={6} sx={{ p: isMobile ? 0.5 : 1 }}>
//             <MainCard
//               title="Shift Notes Form"
//               sx={{
//                 p: isMobile ? 0.5 : 1,
//                 '& .MuiCardContent-root': { p: isMobile ? 0.5 : 1 },
//                 '& .MuiCardHeader-root': { p: 0.5 },
//                 borderRadius: 2
//               }}
//             >
//               <Stepper activeStep={activeStep} orientation="vertical">
//                 <Step>
//                   <StepLabel>Shift Selection</StepLabel>
//                   <StepContent>
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{ mb: 1.5, fontStyle: 'italic' }}
//                     >
//                       Select a completed shift to document notes
//                     </Typography>
//                     <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                       <Button
//                         variant="contained"
//                         onClick={handleNext}
//                         disabled={!selectedShift}
//                         sx={{ mt: 1, borderRadius: 1 }}
//                         color="primary"
//                       >
//                         Continue
//                       </Button>
//                     </Box>
//                   </StepContent>
//                 </Step>

//                 <Step>
//                   <StepLabel>Basic Information</StepLabel>
//                   <StepContent>
//                     <Grid container spacing={1.5}>
//                       <Grid item xs={12}>
//                         <Controller
//                           name="title"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               label="Title *"
//                               size="small"
//                               variant="outlined"
//                               error={!!errors.title}
//                               helperText={errors.title?.message}
//                             />
//                           )}
//                         />
//                       </Grid>

//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="caseNoteDate"
//                           control={control}
//                           render={({ field }) => (
//                             <DatePicker
//                               label="Date *"
//                               value={dayjs(field.value)}
//                               onChange={(date) =>
//                                 field.onChange(date ? dayjs(date).format('YYYY-MM-DD') : '')
//                               }
//                               slotProps={{
//                                 textField: {
//                                   fullWidth: true,
//                                   size: 'small',
//                                   error: !!errors.caseNoteDate,
//                                   helperText: errors.caseNoteDate?.message
//                                 }
//                               }}
//                             />
//                           )}
//                         />
//                       </Grid>
//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="caseNoteTime"
//                           control={control}
//                           render={({ field }) => (
//                             <TimePicker
//                               label="Time *"
//                               value={dayjs(field.value, 'HH:mm A')}
//                               onChange={(time) =>
//                                 field.onChange(time ? dayjs(time).format('HH:mm A') : '')
//                               }
//                               slotProps={{
//                                 textField: {
//                                   fullWidth: true,
//                                   size: 'small',
//                                   error: !!errors.caseNoteTime,
//                                   helperText: errors.caseNoteTime?.message
//                                 }
//                               }}
//                             />
//                           )}
//                         />
//                       </Grid>

//                       <Grid item xs={12}>
//                         <Controller
//                           name="assignToStaff"
//                           control={control}
//                           render={({ field }) => (
//                             <FormControl fullWidth size="small" error={!!errors.assignToStaff}>
//                               <InputLabel>Assign Staff *</InputLabel>
//                               <Select
//                                 {...field}
//                                 multiple
//                                 input={<OutlinedInput label="Assign Staff *" />}
//                                 renderValue={(selected) => (selected as string[]).join(', ')}
//                                 onChange={(event: SelectChangeEvent<string[]>) =>
//                                   field.onChange(event.target.value as string[])
//                                 }
//                               >
//                                 {staffMembers.map((staff) => (
//                                   <MenuItem key={staff} value={staff}>
//                                     <Checkbox
//                                       checked={field.value.indexOf(staff) > -1}
//                                       size="small"
//                                     />
//                                     <Typography variant="body2">{staff}</Typography>
//                                   </MenuItem>
//                                 ))}
//                               </Select>
//                               {!!errors.assignToStaff && (
//                                 <Typography variant="caption" color="error">
//                                   {errors.assignToStaff.message}
//                                 </Typography>
//                               )}
//                             </FormControl>
//                           )}
//                         />
//                       </Grid>

//                       <Grid item xs={12}>
//                         <Controller
//                           name="clientName"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               label="Client Name"
//                               size="small"
//                               variant="outlined"
//                               disabled
//                             />
//                           )}
//                         />
//                       </Grid>

//                       <Grid item xs={12}>
//                         <Controller
//                           name="supportItemNumber"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               label="Support Item Number"
//                               size="small"
//                               variant="outlined"
//                               disabled
//                             />
//                           )}
//                         />
//                       </Grid>

//                       <Grid item xs={12}>
//                         <Controller
//                           name="createdBy"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               label="Created By"
//                               size="small"
//                               variant="outlined"
//                               disabled
//                             />
//                           )}
//                         />
//                       </Grid>
//                     </Grid>
//                     <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
//                       <Button onClick={handleBack} sx={{ mr: 1, borderRadius: 1 }}>
//                         Back
//                       </Button>
//                       <Button variant="contained" onClick={handleNext} sx={{ borderRadius: 1 }}>
//                         Continue
//                       </Button>
//                     </Box>
//                   </StepContent>
//                 </Step>

//                 <Step>
//                   <StepLabel>Care Details</StepLabel>
//                   <StepContent>
//                     <Grid container spacing={1.5}>
//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="medicationReceived"
//                           control={control}
//                           render={({ field }) => (
//                             <FormControl fullWidth size="small" error={!!errors.medicationReceived}>
//                               <InputLabel>Medication *</InputLabel>
//                               <Select
//                                 {...field}
//                                 label="Medication *"
//                                 onChange={(event: SelectChangeEvent<string>) =>
//                                   field.onChange(event.target.value)
//                                 }
//                               >
//                                 {medicationOptions.map((option) => (
//                                   <MenuItem key={option} value={option}>
//                                     {option}
//                                   </MenuItem>
//                                 ))}
//                               </Select>
//                               {!!errors.medicationReceived && (
//                                 <Typography variant="caption" color="error">
//                                   {errors.medicationReceived.message}
//                                 </Typography>
//                               )}
//                             </FormControl>
//                           )}
//                         />
//                       </Grid>
//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="foodProvided"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               label="Food Provided"
//                               size="small"
//                               error={!!errors.foodProvided}
//                               helperText={errors.foodProvided?.message}
//                             />
//                           )}
//                         />
//                       </Grid>

//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="personalCare"
//                           control={control}
//                           render={({ field }) => (
//                             <FormControl fullWidth size="small" error={!!errors.personalCare}>
//                               <InputLabel>Personal Care *</InputLabel>
//                               <Select
//                                 {...field}
//                                 label="Personal Care *"
//                                 onChange={(event: SelectChangeEvent<string>) =>
//                                   field.onChange(event.target.value)
//                                 }
//                               >
//                                 {personalCareOptions.map((option) => (
//                                   <MenuItem key={option} value={option}>
//                                     {option}
//                                   </MenuItem>
//                                 ))}
//                               </Select>
//                               {!!errors.personalCare && (
//                                 <Typography variant="caption" color="error">
//                                   {errors.personalCare.message}
//                                 </Typography>
//                               )}
//                             </FormControl>
//                           )}
//                         />
//                       </Grid>
//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="foodIntakeChartCompleted"
//                           control={control}
//                           render={({ field }) => (
//                             <FormControl fullWidth size="small">
//                               <InputLabel>Food Chart</InputLabel>
//                               <Select
//                                 {...field}
//                                 label="Food Chart"
//                                 onChange={(event: SelectChangeEvent<string>) =>
//                                   field.onChange(event.target.value)
//                                 }
//                               >
//                                 {foodIntakeOptions.map((option) => (
//                                   <MenuItem key={option} value={option}>
//                                     {option}
//                                   </MenuItem>
//                                 ))}
//                               </Select>
//                             </FormControl>
//                           )}
//                         />
//                       </Grid>
//                     </Grid>
//                     <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
//                       <Button onClick={handleBack} sx={{ mr: 1, borderRadius: 1 }}>
//                         Back
//                       </Button>
//                       <Button variant="contained" onClick={handleNext} sx={{ borderRadius: 1 }}>
//                         Continue
//                       </Button>
//                     </Box>
//                   </StepContent>
//                 </Step>

//                 <Step>
//                   <StepLabel>Additional Information</StepLabel>
//                   <StepContent>
//                     <Grid container spacing={1.5}>
//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="participantMood"
//                           control={control}
//                           render={({ field }) => (
//                             <FormControl fullWidth size="small" error={!!errors.participantMood}>
//                               <InputLabel>Mood *</InputLabel>
//                               <Select
//                                 {...field}
//                                 label="Mood *"
//                                 onChange={(event: SelectChangeEvent<string>) =>
//                                   field.onChange(event.target.value)
//                                 }
//                               >
//                                 {moodOptions.map((option) => (
//                                   <MenuItem key={option} value={option}>
//                                     {option}
//                                   </MenuItem>
//                                 ))}
//                               </Select>
//                               {!!errors.participantMood && (
//                                 <Typography variant="caption" color="error">
//                                   {errors.participantMood.message}
//                                 </Typography>
//                               )}
//                             </FormControl>
//                           )}
//                         />
//                       </Grid>
//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="timeTaken"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               label="Time (mins)"
//                               type="number"
//                               size="small"
//                               InputProps={{ inputProps: { min: 0 } }}
//                               error={!!errors.timeTaken}
//                               helperText={errors.timeTaken?.message}
//                             />
//                           )}
//                         />
//                       </Grid>

//                       <Grid item xs={12}>
//                         <Controller
//                           name="goalsMet"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               label="Goals Met"
//                               size="small"
//                               error={!!errors.goalsMet}
//                               helperText={errors.goalsMet?.message}
//                             />
//                           )}
//                         />
//                       </Grid>

//                       <Grid item xs={12}>
//                         <Controller
//                           name="caseNoteDetails"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               multiline
//                               rows={3}
//                               label="Details *"
//                               size="small"
//                               error={!!errors.caseNoteDetails}
//                               helperText={errors.caseNoteDetails?.message}
//                             />
//                           )}
//                         />
//                       </Grid>

//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="rating"
//                           control={control}
//                           render={({ field }) => (
//                             <FormControl fullWidth size="small" error={!!errors.rating}>
//                               <InputLabel>Rating *</InputLabel>
//                               <Select
//                                 {...field}
//                                 label="Rating *"
//                                 onChange={(event: SelectChangeEvent<string>) =>
//                                   field.onChange(event.target.value)
//                                 }
//                               >
//                                 {ratingOptions.map((option) => (
//                                   <MenuItem key={option} value={option}>
//                                     {option}
//                                   </MenuItem>
//                                 ))}
//                               </Select>
//                               {!!errors.rating && (
//                                 <Typography variant="caption" color="error">
//                                   {errors.rating.message}
//                                 </Typography>
//                               )}
//                             </FormControl>
//                           )}
//                         />
//                       </Grid>
//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="securityLevel"
//                           control={control}
//                           render={({ field }) => (
//                             <FormControl fullWidth size="small" error={!!errors.securityLevel}>
//                               <InputLabel>Security Level *</InputLabel>
//                               <Select
//                                 {...field}
//                                 label="Security Level *"
//                                 onChange={(event: SelectChangeEvent<string>) =>
//                                   field.onChange(event.target.value)
//                                 }
//                               >
//                                 {securityLevelOptions.map((option) => (
//                                   <MenuItem key={option} value={option}>
//                                     {option}
//                                   </MenuItem>
//                                 ))}
//                               </Select>
//                               {!!errors.securityLevel && (
//                                 <Typography variant="caption" color="error">
//                                   {errors.securityLevel.message}
//                                 </Typography>
//                               )}
//                             </FormControl>
//                           )}
//                         />
//                       </Grid>
//                     </Grid>
//                     <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
//                       <Button onClick={handleBack} sx={{ mr: 1, borderRadius: 1 }}>
//                         Back
//                       </Button>
//                       <Button variant="contained" onClick={handleNext} sx={{ borderRadius: 1 }}>
//                         Continue
//                       </Button>
//                     </Box>
//                   </StepContent>
//                 </Step>

//                 <Step>
//                   <StepLabel>Review & Submit</StepLabel>
//                   <StepContent>
//                     <Paper variant="outlined" sx={{ p: 1.5, mb: 1.5, borderRadius: 2 }}>
//                       <Typography variant="subtitle1" gutterBottom color="primary">
//                         Shift Information
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Worker:</strong> {selectedShift?.user || 'N/A'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Date:</strong>{' '}
//                         {watch('caseNoteDate')
//                           ? dayjs(watch('caseNoteDate')).format('DD/MM/YYYY')
//                           : 'N/A'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Time:</strong> {watch('caseNoteTime') || 'N/A'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Assigned Staff:</strong>{' '}
//                         {watch('assignToStaff').length > 0
//                           ? watch('assignToStaff').join(', ')
//                           : 'None'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Client:</strong> {watch('clientName') || 'N/A'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Support Item:</strong> {watch('supportItemNumber') || 'N/A'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Created By:</strong> {watch('createdBy') || 'N/A'}
//                       </Typography>

//                       <Divider sx={{ my: 1 }} />

//                       <Typography variant="subtitle1" gutterBottom color="primary">
//                         Care Details
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Medication:</strong>{' '}
//                         {watch('medicationReceived') || 'Not specified'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Food Provided:</strong> {watch('foodProvided') || 'Not specified'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Personal Care:</strong> {watch('personalCare') || 'Not specified'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Food Chart:</strong>{' '}
//                         {watch('foodIntakeChartCompleted') || 'Not specified'}
//                       </Typography>

//                       <Divider sx={{ my: 1 }} />

//                       <Typography variant="subtitle1" gutterBottom color="primary">
//                         Additional Information
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Mood:</strong> {watch('participantMood') || 'Not specified'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Time Taken:</strong>{' '}
//                         {watch('timeTaken') > 0 ? `${watch('timeTaken')} mins` : 'Not specified'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Goals Met:</strong> {watch('goalsMet') || 'Not specified'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Rating:</strong> {watch('rating') || 'Not specified'}
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Security Level:</strong> {watch('securityLevel') || 'Not specified'}
//                       </Typography>
//                       <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
//                         <strong>Details:</strong> {watch('caseNoteDetails') || 'None provided'}
//                       </Typography>
//                     </Paper>
//                     <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                       <Button onClick={handleBack} sx={{ mr: 1, borderRadius: 1 }}>
//                         Back
//                       </Button>
//                       <Button
//                         type="submit"
//                         variant="contained"
//                         sx={{ borderRadius: 1 }}
//                         color="success"
//                       >
//                         Submit
//                       </Button>
//                     </Box>
//                   </StepContent>
//                 </Step>
//               </Stepper>
//             </MainCard>
//           </Grid>

//           <Grid item xs={12} md={6} sx={{ p: isMobile ? 0.5 : 1 }}>
//             <MainCard
//               title={
//                 <Box
//                   display="flex"
//                   flexDirection={isMobile ? 'column' : 'row'}
//                   alignItems={isMobile ? 'flex-start' : 'center'}
//                   justifyContent="space-between"
//                   gap={1}
//                 >
//                   <div>Recent Notes</div>
//                   <DatePicker
//                     label="Filter by Date"
//                     value={dayjs(selectedDate)}
//                     onChange={(date) =>
//                       setSelectedDate(date ? dayjs(date).format('YYYY-MM-DD') : '')
//                     }
//                     slotProps={{
//                       textField: {
//                         size: 'small',
//                         sx: {
//                           width: isMobile ? '100%' : 180,
//                           '& .MuiInputBase-root': {
//                             fontSize: '0.85rem',
//                             height: 36
//                           },
//                           '& .MuiInputLabel-root': {
//                             fontSize: '0.75rem'
//                           }
//                         }
//                       }
//                     }}
//                     format="DD/MM/YYYY"
//                   />
//                 </Box>
//               }
//               sx={{
//                 p: isMobile ? 0.5 : 1,
//                 '& .MuiCardHeader-root': { p: 0.5 },
//                 '& .MuiCardContent-root': {
//                   p: isMobile ? 0.5 : 1,
//                   maxHeight: '70vh',
//                   overflowY: 'auto',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   gap: 1,
//                   '&::-webkit-scrollbar': {
//                     width: '0.4em'
//                   },
//                   '&::-webkit-scrollbar-track': {
//                     boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
//                     webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
//                   },
//                   '&::-webkit-scrollbar-thumb': {
//                     backgroundColor: 'rgba(0,0,0,.1)',
//                     borderRadius: '10px'
//                   }
//                 },
//                 borderRadius: 2
//               }}
//             >
//               {loading ? (
//                 <Typography>Loading...</Typography>
//               ) : error ? (
//                 <Typography color="error">No Notes Found</Typography>
//               ) : shiftNotes.length > 0 ? (
//                 shiftNotes.map((note: ShiftNote) => (
//                   <Card
//                     key={note.id}
//                     sx={{
//                       flexShrink: 0,
//                       borderRadius: 2,
//                       boxShadow: 2,
//                       transition: 'all 0.2s',
//                       '&:hover': {
//                         boxShadow: `0 4px 12px ${theme.palette.grey[300]}`,
//                         transform: 'translateY(-2px)'
//                       },
//                       bgcolor: theme.palette.background.paper,
//                       borderLeft: `4px solid ${
//                         note.status === 'New'
//                           ? theme.palette.success.main
//                           : note.status === 'Completed'
//                           ? theme.palette.primary.main
//                           : theme.palette.warning.main
//                       }`
//                     }}
//                   >
//                     <CardContent sx={{ p: 1.5 }}>
//                       <Box display="flex" justifyContent="space-between" alignItems="flex-start">
//                         <Box>
//                           <Typography variant="subtitle2" fontWeight="bold" color="primary">
//                             {note.title || 'Untitled'}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             {note.worker_name || 'Unknown'} •{' '}
//                             {note.caseNoteDate
//                               ? dayjs(note.caseNoteDate).format('DD/MM/YYYY')
//                               : 'N/A'}{' '}
//                             • {note.caseNoteTime || 'N/A'}
//                           </Typography>
//                         </Box>
//                         <Chip
//                           label={note.status || 'Unknown'}
//                           size="small"
//                           color={
//                             note.status === 'New'
//                               ? 'success'
//                               : note.status === 'Completed'
//                               ? 'primary'
//                               : 'warning'
//                           }
//                           variant="outlined"
//                           sx={{ fontWeight: 'medium' }}
//                         />
//                       </Box>

//                       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, my: 1 }}>
//                         {note.medicationReceived && (
//                           <Chip
//                             label={`Med: ${note.medicationReceived}`}
//                             size="small"
//                             variant="outlined"
//                             color="info"
//                           />
//                         )}
//                         {note.personalCare && (
//                           <Chip
//                             label={`Care: ${note.personalCare}`}
//                             size="small"
//                             variant="outlined"
//                             color="info"
//                           />
//                         )}
//                         {note.participantMood && (
//                           <Chip
//                             label={`Mood: ${note.participantMood}`}
//                             size="small"
//                             variant="outlined"
//                             color="info"
//                           />
//                         )}
//                         {note.rating && (
//                           <Chip
//                             label={`Rating: ${note.rating}`}
//                             size="small"
//                             variant="outlined"
//                             color="info"
//                           />
//                         )}
//                         {note.foodIntakeChartCompleted && (
//                           <Chip
//                             label={`Food Chart: ${note.foodIntakeChartCompleted}`}
//                             size="small"
//                             variant="outlined"
//                             color="info"
//                           />
//                         )}
//                         {note.securityLevel && (
//                           <Chip
//                             label={`Security: ${note.securityLevel}`}
//                             size="small"
//                             variant="outlined"
//                             color="info"
//                           />
//                         )}
//                         {note.assignToStaff && note.assignToStaff.length > 0 && (
//                           <Chip
//                             label={`Assigned: ${note.assignToStaff.join(', ')}`}
//                             size="small"
//                             variant="outlined"
//                             color="info"
//                           />
//                         )}
//                         {note.timeTaken > 0 && (
//                           <Chip
//                             label={`Time: ${note.timeTaken} mins`}
//                             size="small"
//                             variant="outlined"
//                             color="info"
//                           />
//                         )}
//                         {note.supportItemNumber && (
//                           <Chip
//                             label={`Support Item: ${note.supportItemNumber}`}
//                             size="small"
//                             variant="outlined"
//                             color="info"
//                           />
//                         )}
//                       </Box>

//                       {(note.caseNoteDetails ||
//                         note.goalsMet ||
//                         note.foodProvided ||
//                         note.createdBy) && (
//                         <>
//                           <Divider sx={{ my: 0.5 }} />
//                           {note.caseNoteDetails && (
//                             <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mt: 0.5 }}>
//                               <strong>Details:</strong> {note.caseNoteDetails}
//                             </Typography>
//                           )}
//                           {note.goalsMet && (
//                             <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mt: 0.5 }}>
//                               <strong>Goals:</strong> {note.goalsMet}
//                             </Typography>
//                           )}
//                           {note.foodProvided && (
//                             <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mt: 0.5 }}>
//                               <strong>Food Provided:</strong> {note.foodProvided}
//                             </Typography>
//                           )}
//                           {note.createdBy && (
//                             <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mt: 0.5 }}>
//                               <strong>Created By:</strong> {note.createdBy}
//                             </Typography>
//                           )}
//                         </>
//                       )}

//                       <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
//                         <IconButton onClick={() => handleEdit(note)} size="small" color="primary">
//                           <EditIcon fontSize="small" />
//                         </IconButton>
//                         <IconButton onClick={() => handleDelete(note)} size="small" color="error">
//                           <DeleteIcon fontSize="small" />
//                         </IconButton>
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 ))
//               ) : (
//                 <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
//                   No notes available for selected date
//                 </Typography>
//               )}
//             </MainCard>
//           </Grid>

//           <Dialog
//             open={openDialog}
//             onClose={handleDialogClose}
//             fullWidth
//             maxWidth="md"
//             fullScreen={isMobile}
//             sx={{
//               '& .MuiDialogTitle-root': { p: isMobile ? 1 : 1.5, pb: 1 },
//               '& .MuiDialogContent-root': { p: isMobile ? 1 : 1.5 },
//               '& .MuiDialogActions-root': { p: 1 }
//             }}
//           >
//             <DialogTitle>Edit Shift Note</DialogTitle>
//             <DialogContent dividers>
//               {editingNote && (
//                 <Grid container spacing={1.5}>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Title *"
//                       value={editingNote.title || ''}
//                       onChange={(e) => setEditingNote({ ...editingNote, title: e.target.value })}
//                       size="small"
//                       variant="outlined"
//                       error={!editingNote.title || editingNote.title.length > 100}
//                       helperText={
//                         !editingNote.title
//                           ? 'Title is required'
//                           : editingNote.title.length > 100
//                           ? 'Title must be 100 characters or less'
//                           : ''
//                       }
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Worker"
//                       value={editingNote.worker_name || ''}
//                       disabled
//                       size="small"
//                       variant="outlined"
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="Date *"
//                       value={dayjs(editingNote.caseNoteDate)}
//                       onChange={(date) =>
//                         setEditingNote({
//                           ...editingNote,
//                           caseNoteDate: date ? dayjs(date).format('YYYY-MM-DD') : ''
//                         })
//                       }
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           error: !editingNote.caseNoteDate,
//                           helperText: !editingNote.caseNoteDate ? 'Date is required' : ''
//                         }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TimePicker
//                       label="Time *"
//                       value={dayjs(editingNote.caseNoteTime, 'HH:mm A')}
//                       onChange={(time) =>
//                         setEditingNote({
//                           ...editingNote,
//                           caseNoteTime: time ? dayjs(time).format('HH:mm A') : ''
//                         })
//                       }
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           error: !editingNote.caseNoteTime,
//                           helperText: !editingNote.caseNoteTime ? 'Time is required' : ''
//                         }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <FormControl
//                       fullWidth
//                       size="small"
//                       error={!editingNote.assignToStaff || editingNote.assignToStaff.length === 0}
//                     >
//                       <InputLabel>Assign Staff *</InputLabel>
//                       <Select
//                         multiple
//                         value={editingNote.assignToStaff || []}
//                         input={<OutlinedInput label="Assign Staff *" />}
//                         renderValue={(selected) => (selected as string[]).join(', ')}
//                         onChange={(e) =>
//                           setEditingNote({
//                             ...editingNote,
//                             assignToStaff: e.target.value as string[]
//                           })
//                         }
//                       >
//                         {staffMembers.map((staff) => (
//                           <MenuItem key={staff} value={staff}>
//                             <Checkbox
//                               checked={(editingNote.assignToStaff || []).indexOf(staff) > -1}
//                               size="small"
//                             />
//                             <Typography variant="body2">{staff}</Typography>
//                           </MenuItem>
//                         ))}
//                       </Select>
//                       {(!editingNote.assignToStaff || editingNote.assignToStaff.length === 0) && (
//                         <Typography variant="caption" color="error">
//                           At least one staff member must be assigned
//                         </Typography>
//                       )}
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Support Item Number"
//                       value={editingNote.supportItemNumber || ''}
//                       disabled
//                       size="small"
//                       variant="outlined"
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Created By"
//                       value={editingNote.createdBy || ''}
//                       disabled
//                       size="small"
//                       variant="outlined"
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth size="small" error={!editingNote.medicationReceived}>
//                       <InputLabel>Medication *</InputLabel>
//                       <Select
//                         value={editingNote.medicationReceived || ''}
//                         onChange={(e) =>
//                           setEditingNote({
//                             ...editingNote,
//                             medicationReceived: e.target.value as string
//                           })
//                         }
//                         label="Medication *"
//                       >
//                         {medicationOptions.map((option) => (
//                           <MenuItem key={option} value={option}>
//                             {option}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                       {!editingNote.medicationReceived && (
//                         <Typography variant="caption" color="error">
//                           Medication status is required
//                         </Typography>
//                       )}
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Food Provided"
//                       value={editingNote.foodProvided || ''}
//                       onChange={(e) =>
//                         setEditingNote({ ...editingNote, foodProvided: e.target.value })
//                       }
//                       size="small"
//                       error={!!(editingNote.foodProvided && editingNote.foodProvided.length > 200)}
//                       helperText={
//                         editingNote.foodProvided && editingNote.foodProvided.length > 200
//                           ? 'Food Provided must be 200 characters or less'
//                           : ''
//                       }
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth size="small" error={!editingNote.personalCare}>
//                       <InputLabel>Personal Care *</InputLabel>
//                       <Select
//                         value={editingNote.personalCare || ''}
//                         onChange={(e) =>
//                           setEditingNote({
//                             ...editingNote,
//                             personalCare: e.target.value as string
//                           })
//                         }
//                         label="Personal Care *"
//                       >
//                         {personalCareOptions.map((option) => (
//                           <MenuItem key={option} value={option}>
//                             {option}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                       {!editingNote.personalCare && (
//                         <Typography variant="caption" color="error">
//                           Personal Care selection is required
//                         </Typography>
//                       )}
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Food Chart</InputLabel>
//                       <Select
//                         value={editingNote.foodIntakeChartCompleted || ''}
//                         onChange={(e) =>
//                           setEditingNote({
//                             ...editingNote,
//                             foodIntakeChartCompleted: e.target.value as string
//                           })
//                         }
//                         label="Food Chart"
//                       >
//                         {foodIntakeOptions.map((option) => (
//                           <MenuItem key={option} value={option}>
//                             {option}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth size="small" error={!editingNote.participantMood}>
//                       <InputLabel>Mood *</InputLabel>
//                       <Select
//                         value={editingNote.participantMood || ''}
//                         onChange={(e) =>
//                           setEditingNote({
//                             ...editingNote,
//                             participantMood: e.target.value as string
//                           })
//                         }
//                         label="Mood *"
//                       >
//                         {moodOptions.map((option) => (
//                           <MenuItem key={option} value={option}>
//                             {option}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                       {!editingNote.participantMood && (
//                         <Typography variant="caption" color="error">
//                           Mood selection is required
//                         </Typography>
//                       )}
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Time (mins)"
//                       type="number"
//                       value={editingNote.timeTaken || 0}
//                       onChange={(e) =>
//                         setEditingNote({
//                           ...editingNote,
//                           timeTaken: parseInt(e.target.value) || 0
//                         })
//                       }
//                       size="small"
//                       error={editingNote.timeTaken < 0 || editingNote.timeTaken > 1440}
//                       helperText={
//                         editingNote.timeTaken < 0
//                           ? 'Time cannot be negative'
//                           : editingNote.timeTaken > 1440
//                           ? 'Time cannot exceed 24 hours'
//                           : ''
//                       }
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label="Goals Met"
//                       value={editingNote.goalsMet || ''}
//                       onChange={(e) => setEditingNote({ ...editingNote, goalsMet: e.target.value })}
//                       size="small"
//                       error={!!(editingNote.goalsMet && editingNote.goalsMet.length > 500)}
//                       helperText={
//                         editingNote.goalsMet && editingNote.goalsMet.length > 500
//                           ? 'Goals Met must be 500 characters or less'
//                           : ''
//                       }
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth size="small" error={!editingNote.rating}>
//                       <InputLabel>Rating *</InputLabel>
//                       <Select
//                         value={editingNote.rating || ''}
//                         onChange={(e) =>
//                           setEditingNote({
//                             ...editingNote,
//                             rating: e.target.value as string
//                           })
//                         }
//                         label="Rating *"
//                       >
//                         {ratingOptions.map((option) => (
//                           <MenuItem key={option} value={option}>
//                             {option}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                       {!editingNote.rating && (
//                         <Typography variant="caption" color="error">
//                           Rating is required
//                         </Typography>
//                       )}
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth size="small" error={!editingNote.securityLevel}>
//                       <InputLabel>Security Level *</InputLabel>
//                       <Select
//                         value={editingNote.securityLevel || ''}
//                         onChange={(e) =>
//                           setEditingNote({
//                             ...editingNote,
//                             securityLevel: e.target.value as string
//                           })
//                         }
//                         label="Security Level *"
//                       >
//                         {securityLevelOptions.map((option) => (
//                           <MenuItem key={option} value={option}>
//                             {option}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                       {!editingNote.securityLevel && (
//                         <Typography variant="caption" color="error">
//                           Security Level is required
//                         </Typography>
//                       )}
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       multiline
//                       rows={3}
//                       label="Details *"
//                       value={editingNote.caseNoteDetails || ''}
//                       onChange={(e) =>
//                         setEditingNote({ ...editingNote, caseNoteDetails: e.target.value })
//                       }
//                       size="small"
//                       error={
//                         !editingNote.caseNoteDetails || editingNote.caseNoteDetails.length > 2000
//                       }
//                       helperText={
//                         !editingNote.caseNoteDetails
//                           ? 'Details are required'
//                           : editingNote.caseNoteDetails.length > 2000
//                           ? 'Details must be 2000 characters or less'
//                           : ''
//                       }
//                     />
//                   </Grid>
//                 </Grid>
//               )}
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={handleDialogClose} size="small" variant="outlined">
//                 Cancel
//               </Button>
//               <Button
//                 onClick={handleDialogSave}
//                 color="primary"
//                 size="small"
//                 variant="contained"
//                 disabled={
//                   !editingNote?.title ||
//                   editingNote.title.length > 100 ||
//                   !editingNote?.caseNoteDate ||
//                   !editingNote?.caseNoteTime ||
//                   !editingNote?.assignToStaff?.length ||
//                   !editingNote?.medicationReceived ||
//                   !editingNote?.personalCare ||
//                   !editingNote?.participantMood ||
//                   !editingNote?.rating ||
//                   !editingNote?.securityLevel ||
//                   !editingNote?.caseNoteDetails ||
//                   editingNote.caseNoteDetails.length > 2000 ||
//                   (editingNote.foodProvided && editingNote.foodProvided.length > 200) ||
//                   (editingNote.goalsMet && editingNote.goalsMet.length > 500) ||
//                   editingNote.timeTaken < 0 ||
//                   editingNote.timeTaken > 1440
//                 }
//               >
//                 Save
//               </Button>
//             </DialogActions>
//           </Dialog>
//         </Grid>
//       </form>
//     </Box>
//   );
// };

// export default ShiftNotes;

import React, { useEffect, useState } from 'react';
import {
  Grid,
  Box,
  Card,
  Typography,
  TextField,
  Button,
  CardContent,
  Divider,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Chip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  OutlinedInput,
  SelectChangeEvent,
  useMediaQuery,
  CardActionArea,
  Snackbar,
  Alert,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Paper
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { useTheme } from '@mui/material/styles';
import MainCard from 'ui-component/cards/MainCard';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import {
  fetchShiftNotes,
  addShiftNote,
  updateShiftNote,
  removeShiftNote,
  fetchCompletedShifts
} from '../../../slices/NdisSlices/shiftDetails/shiftNotesSlice';
import { RootState } from 'store';
import { useAppSelector } from 'app/hooks';
import {
  ShiftNote,
  ShiftNotesRequestBody,
  AddShiftNoteRequest,
  FormData,
  CompletedShift
} from '../../../types/ndisSection/shiftNotesTypes';
import { useClientContext } from '../ProfileMainPage';
import dayjs from 'dayjs';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { fetchStaffByRoles } from 'slices/NdisSlices/calenderEvents/CalenderEventsSlice';

// Options for form fields
const personalCareOptions = [
  'Bath',
  'Continence Care',
  'Dressing',
  'None',
  'Oral Hygiene',
  'Other',
  'Shower'
];
const goalOptions = {
  ShortTerm: [
    'Be able to go out more',
    'Go out to picnics',
    'Get new glasses prescription',
    'Find new OT',
    'Dental check-up (gvt dental clinic)'
  ],
  LongTerm: [
    'Participate in more community activities',
    'Be able to travel longer distances',
    'Road trips'
  ]
};

const allGoalOptions = [...goalOptions.ShortTerm, ...goalOptions.LongTerm];
//
const moodOptions = ['Fair', 'Good', 'Poor'];
const ratingOptions = ['Critical', 'Important', 'FYI'];
const securityLevelOptions = ['Low', 'Medium', 'High'];
const medicationOptions = ['Yes', 'No', 'Other'];
const foodIntakeOptions = ['Yes', 'No'];

const steps = [
  'Shift Selection',
  'Basic Information',
  'Care Details',
  'Additional Information',
  'Review & Submit'
];

// Yup validation schema
const validationSchema = Yup.object().shape({
  clientName: Yup.string(),
  title: Yup.string()
    .required('Title is required')
    .max(100, 'Title must be 100 characters or less'),
  caseNoteDate: Yup.string().required('Date is required'),
  caseNoteTime: Yup.string().required('Time is required'),
  assignToStaff: Yup.array()
    .of(Yup.string())
    .min(1, 'At least one staff member must be assigned')
    .required('At least one staff member must be assigned'),
  medicationReceived: Yup.string().required('Medication status is required'),
  foodProvided: Yup.string().max(200, 'Food Provided must be 200 characters or less'),
  personalCare: Yup.string().required('Personal Care selection is required'),
  foodIntakeChartCompleted: Yup.string(),
  participantMood: Yup.string().required('Mood selection is required'),
  goalsMet: Yup.array()
    .of(Yup.string())
    .max(500, 'Goals Met selection is too long when combined')
    .required('At least one goal must be selected'),
  caseNoteDetails: Yup.string()
    .required('Details are required')
    .max(2000, 'Details must be 2000 characters or less'),
  timeTaken: Yup.number()
    .min(0, 'Time cannot be negative')
    .max(1440, 'Time cannot exceed 24 hours'),
  rating: Yup.string().required('Rating is required'),
  securityLevel: Yup.string().required('Security Level is required'),
  supportItemNumber: Yup.string(),
  createdBy: Yup.string()
}) as Yup.ObjectSchema<FormData>;

interface StaffMember {
  id: string;
  name: string;
}
const ShiftNotes: React.FC = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { selectedClient } = useClientContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const staffList = useAppSelector((state) => state.calendarEvents.staffList || {});
  const supportWorkers = staffList?.['Support worker'] || [];
  const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
  const selectedServiceTitle = useAppSelector(
    (state) => state.serviceSelected.selectedServiceTitle
  );
  const userDetailsData = localStorage.getItem('user-details');
  const userDetails = JSON.parse(userDetailsData || '{}');
  const loggedInWorkerName = userDetails?.name || '';
  const location = useLocation();
  const componentParentId = location.pathname;

  const [activeStep, setActiveStep] = useState(0);

  // Redux state
  const { shiftNotes, loading, error, completedShifts } = useSelector(
    (state: RootState) => state.shiftNotes
  );
  const [editingNote, setEditingNote] = useState<ShiftNote | null>(null);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<string>(dayjs().format('YYYY-MM-DD'));
  const [staffMembers, setStaffMembers] = useState<StaffMember[]>(supportWorkers);
  const [selectedShift, setSelectedShift] = useState<CompletedShift | null>(null);
  const [toast, setToast] = useState<{
    open: boolean;
    message: string;
    severity: 'error' | 'success' | 'info';
  }>({
    open: false,
    message: '',
    severity: 'error'
  });



 

  // React Hook Form with Yup validation
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
    trigger
  } = useForm<FormData>({
    defaultValues: {
      clientName: selectedClient?.label || '',
      title: '',
      caseNoteDate: selectedShift?.shiftDate || dayjs().format('YYYY-MM-DD'),
      caseNoteTime: dayjs().format('HH:mm A'),
      assignToStaff: [],
      medicationReceived: '',
      foodProvided: '',
      personalCare: '',
      foodIntakeChartCompleted: '',
      participantMood: '',
      goalsMet: [],
      caseNoteDetails: '',
      timeTaken: 0,
      rating: '',
      securityLevel: '',
      supportItemNumber: '',
      createdBy: loggedInWorkerName
    },
    resolver: yupResolver(validationSchema),
    mode: 'onChange'
  });

  // Watch for selectedShift changes to update form fields
  useEffect(() => {
    if (selectedShift) {
      setValue('caseNoteDate', selectedShift.shiftDate, { shouldValidate: true });
      setValue('caseNoteTime', selectedShift.shiftStartTime, { shouldValidate: true });
      setValue('title', selectedShift.title || '', { shouldValidate: true });
      setValue('assignToStaff', [selectedShift.user, selectedShift.manager].filter(Boolean), {
        shouldValidate: true
      });
      setValue('clientName', selectedClient?.label || '', { shouldValidate: true });
      setValue('caseNoteDetails', selectedShift.description || '', { shouldValidate: true });
      setValue('supportItemNumber', selectedShift.supportItemNumber || '', {
        shouldValidate: true
      });
      setValue('createdBy', selectedShift.createdBy || loggedInWorkerName, {
        shouldValidate: true
      });
      setValue('goalsMet', selectedShift?.goalsMet || [], { shouldValidate: true });
    }
  }, [selectedShift, setValue, selectedClient]);

  

  useEffect(() => {
    if (!selectedProjectId || !selectedServiceTitle || !componentParentId || !selectedClient)
      return;

    const commonPayload = {
      group_id: selectedProjectId,
      service_name_id: selectedServiceTitle,
      component_parent_id: componentParentId,
      nested_component_id: 'Shift-notes',
      user_whoRequested_id: selectedClient.label,
      client_name: selectedClient.label,
      shift_date: selectedDate
    };

    // Dispatch shift-related data
    dispatch(fetchCompletedShifts(commonPayload));
    dispatch(fetchShiftNotes(commonPayload));

    // Prepare and dispatch staff payload only once
    const approvedUser = userDetails?.email?.split('@')[0]?.replace('.', '_') || '';
    const staffPayload = {
      group_id: selectedProjectId,
      service_name_id: selectedServiceTitle,
      nested_component_id: 'Shift-notes',
      email_loggedIn_userEmail: userDetails?.email || '',
      roles: [userDetails?.role],
      client_name: selectedClient.label,
      approved_user: approvedUser,
      curr_loggIn_userRoles: userDetails?.name || ''
    };

    dispatch(fetchStaffByRoles(staffPayload));
  }, [
    dispatch,
    selectedDate,
    selectedServiceTitle,
    selectedClient,
  
  ]);

  useEffect(() => {
    console.log('Current shiftNotes:', shiftNotes);
    console.log('Current completedShifts:', completedShifts);
  }, [shiftNotes, completedShifts]);

  // Define fields to validate for each step
  const stepFields: { [key: number]: (keyof FormData)[] } = {
    0: [],
    1: ['title', 'caseNoteDate', 'caseNoteTime', 'assignToStaff'],
    2: ['medicationReceived', 'personalCare'],
    3: ['participantMood', 'caseNoteDetails', 'rating', 'securityLevel', 'goalsMet'],
    4: []
  };

  // Handlers
  const handleNext = async () => {
    if (activeStep === 0) {
      if (!selectedShift) {
        setToast({
          open: true,
          message: 'Please select a completed shift',
          severity: 'error'
        });
        return;
      }
      setActiveStep((prev) => prev + 1);
      return;
    }

    const fieldsToValidate = stepFields[activeStep];
    const isValid = await trigger(fieldsToValidate);

    if (!isValid) {
      const errorMessages = fieldsToValidate
        .map((field) => errors[field]?.message)
        .filter(Boolean)
        .join(', ');

      setToast({
        open: true,
        message: `Please correct the following errors: ${
          errorMessages || 'Required fields are missing'
        }`,
        severity: 'error'
      });
      return;
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleEdit = (note: ShiftNote) => {
    setEditingNote(note);
    setOpenDialog(true);
  };

  const handleDelete = (shiftNote: ShiftNote) => {
    const reqBody = {
      group_id: selectedProjectId || '',
      service_name_id: selectedServiceTitle || '',
      component_parent_id: componentParentId,
      nested_component_id: 'Shift-notes',
      user_whoRequested_id: selectedClient?.label || '',
      event_id: shiftNote.shift_id,
      shift_date: selectedDate
    };
    dispatch(removeShiftNote(reqBody));
    setToast({
      open: true,
      message: 'Shift note deleted successfully',
      severity: 'success'
    });
    const fetchReqBody: ShiftNotesRequestBody = {
      group_id: selectedProjectId || '',
      service_name_id: selectedServiceTitle || '',
      component_parent_id: componentParentId,
      nested_component_id: 'Shift-notes',
      user_whoRequested_id: selectedClient?.label || '',
      shift_date: selectedDate
    };
    setTimeout(() => {
      dispatch(fetchShiftNotes(fetchReqBody));
    }, 500);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setEditingNote(null);
  };

  const handleDialogSave = () => {
    if (editingNote) {
      const updatedNotes = shiftNotes.map((note) =>
        note.shift_id === editingNote.shift_id ? editingNote : note
      );
      dispatch({
        type: 'shiftNotes/updateShiftNoteSuccess',
        payload: editingNote
      });
      dispatch(updateShiftNote(editingNote as AddShiftNoteRequest));
      setToast({
        open: true,
        message: 'Shift note updated successfully',
        severity: 'success'
      });
      handleDialogClose();
      const fetchReqBody: ShiftNotesRequestBody = {
        group_id: selectedProjectId || '',
        service_name_id: selectedServiceTitle || '',
        component_parent_id: componentParentId,
        nested_component_id: 'Shift-notes',
        user_whoRequested_id: selectedClient?.label || '',
        shift_date: selectedDate
      };
      setTimeout(() => {
        dispatch(fetchShiftNotes(fetchReqBody));
      }, 500);
    }
  };

  const handleShiftSelect = (shift: CompletedShift) => {
    setSelectedShift(shift);
  };

  const handleToastClose = () => {
    setToast({ ...toast, open: false });
  };

  const onSubmit = (values: FormData) => {
    if (!selectedShift) {
      setToast({
        open: true,
        message: 'Please select a completed shift',
        severity: 'error'
      });
      return;
    }

    const newShiftNote: AddShiftNoteRequest = {
      group_id: selectedProjectId || '',
      service_name_id: selectedServiceTitle || '',
      component_parent_id: componentParentId,
      nested_component_id: 'Shift-notes',
      user_whoRequested_id: selectedClient?.label || '',
      shift_id: selectedShift.id,
      worker_name: selectedShift.user,
      shift_date: selectedShift.shiftDate,
      shift_time: values.caseNoteTime,
      shift_details: values.caseNoteDetails,
      status: 'New',
      shift_date_filter: selectedDate,
      clientName: values.clientName,
      title: values.title,
      caseNoteDate: values.caseNoteDate,
      caseNoteTime: values.caseNoteTime,
      assignToStaff: values.assignToStaff,
      medicationReceived: values.medicationReceived,
      foodProvided: values.foodProvided,
      personalCare: values.personalCare,
      foodIntakeChartCompleted: values.foodIntakeChartCompleted,
      participantMood: values.participantMood,
      goalsMet: values.goalsMet,
      caseNoteDetails: values.caseNoteDetails,
      timeTaken: values.timeTaken,
      rating: values.rating,
      securityLevel: values.securityLevel,
      shiftStartTime: selectedShift.shiftStartTime,
      shiftEndTime: selectedShift.shiftEndTime,
      supportItemNumber: values.supportItemNumber,
      createdBy: values.createdBy || loggedInWorkerName
    };

    dispatch({
      type: 'shiftNotes/addShiftNoteSuccess',
      payload: newShiftNote
    });
    dispatch(addShiftNote(newShiftNote));
    setToast({
      open: true,
      message: 'Shift note added successfully',
      severity: 'success'
    });
    reset();
    setSelectedShift(null);
    setActiveStep(0);
    const fetchReqBody: ShiftNotesRequestBody = {
      group_id: selectedProjectId || '',
      service_name_id: selectedServiceTitle || '',
      component_parent_id: componentParentId || '',
      nested_component_id: 'Shift-notes',
      user_whoRequested_id: selectedClient?.label || '',
      shift_date: selectedDate
    };
    setTimeout(() => {
      dispatch(fetchShiftNotes(fetchReqBody));
    }, 500);

  };
  return (
    <Box sx={{ width: '100%', m: 1 }}>
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={handleToastClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleToastClose} severity={toast.severity} sx={{ width: '100%' }}>
          {toast.message}
        </Alert>
      </Snackbar>

      <MainCard
        title="Completed Shifts"
        sx={{
          p: isMobile ? 0.5 : 1,
          '& .MuiCardHeader-root': { p: 0.5 },
          '& .MuiCardContent-root': { p: isMobile ? 0.5 : 1 }
        }}
      >
        {loading ? (
          <Typography>Loading...</Typography>
        ) : error ? (
          <Typography color="error">No completed shifts found</Typography>
        ) : completedShifts.length > 0 ? (
          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              gap: 1.5,
              py: 0.5,
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': {
                height: '6px'
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: theme.palette.grey[400],
                borderRadius: '3px'
              }
            }}
          >
            {completedShifts.map((shift) => (
              <Card
                key={shift.id}
                sx={{
                  minWidth: isMobile ? 160 : 180,
                  width: isMobile ? 160 : 180,
                  border:
                    selectedShift?.id === shift.id
                      ? `2px solid ${theme.palette.primary.main}`
                      : '1px solid rgba(0, 0, 0, 0.12)',
                  boxShadow:
                    selectedShift?.id === shift.id
                      ? `0 0 8px ${theme.palette.primary.light}`
                      : '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'all 0.2s',
                  '&:hover': {
                    boxShadow: `0 4px 8px rgba(0,0,0,0.15)`,
                    cursor: 'pointer',
                    transform: 'translateY(-2px)'
                  },
                  flexShrink: 0,
                  borderRadius: 2,
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <CardActionArea onClick={() => handleShiftSelect(shift)} sx={{ flexGrow: 1 }}>
                  <CardContent sx={{ p: 1 }}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      mb={0.5}
                    >
                      <Typography
                        variant="subtitle2"
                        fontWeight="bold"
                        noWrap
                        sx={{
                          maxWidth: 100,
                          textOverflow: 'ellipsis',
                          overflow: 'hidden'
                        }}
                      >
                        {shift.user}
                      </Typography>
                      <Chip
                        label={shift.status}
                        variant="outlined"
                        color="success"
                        size="small"
                        sx={{
                          height: 20,
                          fontSize: '0.675rem',
                          fontWeight: 500,
                          borderRadius: '6px',
                          borderColor: 'success.main',
                          color: 'success.dark',
                          backgroundColor: '#e6f4ea',
                          '& .MuiChip-label': {
                            px: 1,
                            py: 0.25
                          }
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: theme.palette.grey[100],
                        borderRadius: 1,
                        p: 0.5,
                        mb: 0.5
                      }}
                    >
                      <Typography variant="caption" fontWeight="bold" display="block">
                        {dayjs(shift.shiftDate).format('DD MMM')}
                      </Typography>
                      <Typography variant="caption" display="block" color="text.secondary">
                        {shift.shiftStartTime} - {shift.shiftEndTime}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                      <Typography variant="caption" fontWeight="bold">
                        Total:
                      </Typography>
                      <Typography variant="caption">{shift.totalTime}</Typography>
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: theme.palette.primary.light,
                        borderRadius: 1,
                        p: 0.5,
                        textAlign: 'center'
                      }}
                    >
                      <Typography variant="caption" fontWeight="bold">
                        #{shift.title}
                      </Typography>
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No completed shifts available
          </Typography>
        )}
      </MainCard>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1} sx={{ width: '100%' }}>
          <Grid item xs={12} md={6} sx={{ p: isMobile ? 0.5 : 1 }}>
            <MainCard
              title="Shift Notes Form"
              sx={{
                p: isMobile ? 0.5 : 1,
                '& .MuiCardContent-root': { p: isMobile ? 0.5 : 1 },
                '& .MuiCardHeader-root': { p: 0.5 },
                borderRadius: 2
              }}
            >
              <Stepper activeStep={activeStep} orientation="vertical">
                <Step>
                  <StepLabel>Shift Selection</StepLabel>
                  <StepContent>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 1.5, fontStyle: 'italic' }}
                    >
                      Select a completed shift to document notes
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <Button
                        variant="contained"
                        onClick={handleNext}
                        disabled={!selectedShift}
                        sx={{ mt: 1, borderRadius: 1 }}
                        color="primary"
                      >
                        Continue
                      </Button>
                    </Box>
                  </StepContent>
                </Step>

                <Step>
                  <StepLabel>Basic Information</StepLabel>
                  <StepContent>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12}>
                        <Controller
                          name="title"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              fullWidth
                              label="Title *"
                              size="small"
                              variant="outlined"
                              error={!!errors.title}
                              helperText={errors.title?.message}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Controller
                          name="caseNoteDate"
                          control={control}
                          render={({ field }) => (
                            <DatePicker
                              label="Date *"
                              value={dayjs(field.value)}
                              onChange={(date) =>
                                field.onChange(date ? dayjs(date).format('YYYY-MM-DD') : '')
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  size: 'small',
                                  error: !!errors.caseNoteDate,
                                  helperText: errors.caseNoteDate?.message
                                }
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Controller
                          name="caseNoteTime"
                          control={control}
                          render={({ field }) => (
                            <TimePicker
                              label="Time *"
                              value={dayjs(field.value, 'HH:mm A')}
                              onChange={(time) =>
                                field.onChange(time ? dayjs(time).format('HH:mm A') : '')
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  size: 'small',
                                  error: !!errors.caseNoteTime,
                                  helperText: errors.caseNoteTime?.message
                                }
                              }}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Controller
                          name="assignToStaff"
                          control={control}
                          render={({ field }) => (
                            <FormControl fullWidth size="small" error={!!errors.assignToStaff}>
                              <InputLabel>Assign Staff *</InputLabel>
                              <Select
                                {...field}
                                multiple
                                input={<OutlinedInput label="Assign Staff *" />}
                                renderValue={(selected) => (selected as string[]).join(', ')}
                                onChange={(event: SelectChangeEvent<string[]>) =>
                                  field.onChange(event.target.value as string[])
                                }
                              >
                                {supportWorkers.map((staff) => (
                                  <MenuItem key={staff?.id} value={staff?.name}>
                                    <Checkbox
                                      checked={field.value.indexOf(staff?.name) > -1}
                                      size="small"
                                    />
                                    <Typography variant="body2">{staff?.name}</Typography>
                                  </MenuItem>
                                ))}
                              </Select>
                              {!!errors.assignToStaff && (
                                <Typography variant="caption" color="error">
                                  {errors.assignToStaff.message}
                                </Typography>
                              )}
                            </FormControl>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Controller
                          name="clientName"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              fullWidth
                              label="Client Name"
                              size="small"
                              variant="outlined"
                              disabled
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Controller
                          name="supportItemNumber"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              fullWidth
                              label="Support Item Number"
                              size="small"
                              variant="outlined"
                              disabled
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Controller
                          name="createdBy"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              fullWidth
                              label="Created By"
                              size="small"
                              variant="outlined"
                              disabled
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
                      <Button onClick={handleBack} sx={{ mr: 1, borderRadius: 1 }}>
                        Back
                      </Button>
                      <Button variant="contained" onClick={handleNext} sx={{ borderRadius: 1 }}>
                        Continue
                      </Button>
                    </Box>
                  </StepContent>
                </Step>

                <Step>
                  <StepLabel>Care Details</StepLabel>
                  <StepContent>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={6}>
                        <Controller
                          name="medicationReceived"
                          control={control}
                          render={({ field }) => (
                            <FormControl fullWidth size="small" error={!!errors.medicationReceived}>
                              <InputLabel>Medication *</InputLabel>
                              <Select
                                {...field}
                                label="Medication *"
                                onChange={(event: SelectChangeEvent<string>) =>
                                  field.onChange(event.target.value)
                                }
                              >
                                {medicationOptions.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                              {!!errors.medicationReceived && (
                                <Typography variant="caption" color="error">
                                  {errors.medicationReceived.message}
                                </Typography>
                              )}
                            </FormControl>
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Controller
                          name="foodProvided"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              fullWidth
                              label="Food Provided"
                              size="small"
                              error={!!errors.foodProvided}
                              helperText={errors.foodProvided?.message}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Controller
                          name="personalCare"
                          control={control}
                          render={({ field }) => (
                            <FormControl fullWidth size="small" error={!!errors.personalCare}>
                              <InputLabel>Personal Care *</InputLabel>
                              <Select
                                {...field}
                                label="Personal Care *"
                                onChange={(event: SelectChangeEvent<string>) =>
                                  field.onChange(event.target.value)
                                }
                              >
                                {personalCareOptions.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                              {!!errors.personalCare && (
                                <Typography variant="caption" color="error">
                                  {errors.personalCare.message}
                                </Typography>
                              )}
                            </FormControl>
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Controller
                          name="foodIntakeChartCompleted"
                          control={control}
                          render={({ field }) => (
                            <FormControl fullWidth size="small">
                              <InputLabel>Food Chart</InputLabel>
                              <Select
                                {...field}
                                label="Food Chart"
                                onChange={(event: SelectChangeEvent<string>) =>
                                  field.onChange(event.target.value)
                                }
                              >
                                {foodIntakeOptions.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
                      <Button onClick={handleBack} sx={{ mr: 1, borderRadius: 1 }}>
                        Back
                      </Button>
                      <Button variant="contained" onClick={handleNext} sx={{ borderRadius: 1 }}>
                        Continue
                      </Button>
                    </Box>
                  </StepContent>
                </Step>

                <Step>
                  <StepLabel>Additional Information</StepLabel>
                  <StepContent>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={6}>
                        <Controller
                          name="participantMood"
                          control={control}
                          render={({ field }) => (
                            <FormControl fullWidth size="small" error={!!errors.participantMood}>
                              <InputLabel>Mood *</InputLabel>
                              <Select
                                {...field}
                                label="Mood *"
                                onChange={(event: SelectChangeEvent<string>) =>
                                  field.onChange(event.target.value)
                                }
                              >
                                {moodOptions.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                              {!!errors.participantMood && (
                                <Typography variant="caption" color="error">
                                  {errors.participantMood.message}
                                </Typography>
                              )}
                            </FormControl>
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Controller
                          name="timeTaken"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              fullWidth
                              label="Time (mins)"
                              type="number"
                              size="small"
                              InputProps={{ inputProps: { min: 0 } }}
                              error={!!errors.timeTaken}
                              helperText={errors.timeTaken?.message}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Controller
                          name="goalsMet"
                          control={control}
                          render={({ field }) => (
                            <FormControl fullWidth size="small" error={!!errors.goalsMet}>
                              <InputLabel sx={{ fontSize: '0.875rem' }}>Goals Met *</InputLabel>
                              <Select
                                {...field}
                                multiple
                                input={
                                  <OutlinedInput
                                    label="Goals Met *"
                                    sx={{ fontSize: '0.875rem' }}
                                  />
                                }
                                renderValue={(selected) => (selected as string[]).join(', ')}
                                onChange={(event: SelectChangeEvent<string[]>) =>
                                  field.onChange(event.target.value as string[])
                                }
                                MenuProps={{
                                  PaperProps: {
                                    sx: {
                                      maxHeight: 300,
                                      marginTop: '4px'
                                    }
                                  }
                                }}
                              >
                                {allGoalOptions.map((option) => (
                                  <MenuItem
                                    key={option}
                                    value={option}
                                    dense
                                    sx={{
                                      py: 0.5,
                                      minHeight: 'auto'
                                    }}
                                  >
                                    <Checkbox
                                      checked={field.value.indexOf(option) > -1}
                                      size="small"
                                      sx={{
                                        py: 0,
                                        '& .MuiSvgIcon-root': { fontSize: '1rem' }
                                      }}
                                    />
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontSize: '0.8rem',
                                        lineHeight: 1.3,
                                        ml: 0.5
                                      }}
                                    >
                                      {option}
                                      <Box
                                        component="span"
                                        sx={{
                                          color: 'text.secondary',
                                          fontSize: '0.75rem',
                                          ml: 0.5
                                        }}
                                      >
                                        {goalOptions.ShortTerm.includes(option)
                                          ? '(Short-Term)'
                                          : '(Long-Term)'}
                                      </Box>
                                    </Typography>
                                  </MenuItem>
                                ))}
                              </Select>
                              {!!errors.goalsMet && (
                                <Typography
                                  variant="caption"
                                  color="error"
                                  sx={{ fontSize: '0.75rem' }}
                                >
                                  {errors.goalsMet.message}
                                </Typography>
                              )}
                            </FormControl>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Controller
                          name="caseNoteDetails"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              fullWidth
                              multiline
                              rows={3}
                              label="Details *"
                              size="small"
                              error={!!errors.caseNoteDetails}
                              helperText={errors.caseNoteDetails?.message}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Controller
                          name="rating"
                          control={control}
                          render={({ field }) => (
                            <FormControl fullWidth size="small" error={!!errors.rating}>
                              <InputLabel>Rating *</InputLabel>
                              <Select
                                {...field}
                                label="Rating *"
                                onChange={(event: SelectChangeEvent<string>) =>
                                  field.onChange(event.target.value)
                                }
                              >
                                {ratingOptions.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                              {!!errors.rating && (
                                <Typography variant="caption" color="error">
                                  {errors.rating.message}
                                </Typography>
                              )}
                            </FormControl>
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Controller
                          name="securityLevel"
                          control={control}
                          render={({ field }) => (
                            <FormControl fullWidth size="small" error={!!errors.securityLevel}>
                              <InputLabel>Security Level *</InputLabel>
                              <Select
                                {...field}
                                label="Security Level *"
                                onChange={(event: SelectChangeEvent<string>) =>
                                  field.onChange(event.target.value)
                                }
                              >
                                {securityLevelOptions.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                              {!!errors.securityLevel && (
                                <Typography variant="caption" color="error">
                                  {errors.securityLevel.message}
                                </Typography>
                              )}
                            </FormControl>
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
                      <Button onClick={handleBack} sx={{ mr: 1, borderRadius: 1 }}>
                        Back
                      </Button>
                      <Button variant="contained" onClick={handleNext} sx={{ borderRadius: 1 }}>
                        Continue
                      </Button>
                    </Box>
                  </StepContent>
                </Step>

                <Step>
                  <StepLabel>Review & Submit</StepLabel>
                  <StepContent>
                    <Paper variant="outlined" sx={{ p: 1.5, mb: 1.5, borderRadius: 2 }}>
                      <Typography variant="subtitle1" gutterBottom color="primary">
                        Shift Information
                      </Typography>
                      <Typography variant="body2">
                        <strong>Worker:</strong> {selectedShift?.user || 'N/A'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Date:</strong>{' '}
                        {watch('caseNoteDate')
                          ? dayjs(watch('caseNoteDate')).format('DD/MM/YYYY')
                          : 'N/A'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Time:</strong> {watch('caseNoteTime') || 'N/A'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Assigned Staff:</strong>{' '}
                        {watch('assignToStaff').length > 0
                          ? watch('assignToStaff').join(', ')
                          : 'None'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Client:</strong> {watch('clientName') || 'N/A'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Support Item:</strong> {watch('supportItemNumber') || 'N/A'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Created By:</strong> {watch('createdBy') || 'N/A'}
                      </Typography>

                      <Divider sx={{ my: 1 }} />

                      <Typography variant="subtitle1" gutterBottom color="primary">
                        Care Details
                      </Typography>
                      <Typography variant="body2">
                        <strong>Medication:</strong>{' '}
                        {watch('medicationReceived') || 'Not specified'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Food Provided:</strong> {watch('foodProvided') || 'Not specified'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Personal Care:</strong> {watch('personalCare') || 'Not specified'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Food Chart:</strong>{' '}
                        {watch('foodIntakeChartCompleted') || 'Not specified'}
                      </Typography>

                      <Divider sx={{ my: 1 }} />

                      <Typography variant="subtitle1" gutterBottom color="primary">
                        Additional Information
                      </Typography>
                      <Typography variant="body2">
                        <strong>Mood:</strong> {watch('participantMood') || 'Not specified'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Time Taken:</strong>{' '}
                        {watch('timeTaken') > 0 ? `${watch('timeTaken')} mins` : 'Not specified'}
                      </Typography>

                      <Typography variant="body2">
                        <strong>Goals Met:</strong>{' '}
                        {watch('goalsMet').length > 0
                          ? watch('goalsMet').join(', ')
                          : 'Not specified'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Rating:</strong> {watch('rating') || 'Not specified'}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Security Level:</strong> {watch('securityLevel') || 'Not specified'}
                      </Typography>
                      <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                        <strong>Details:</strong> {watch('caseNoteDetails') || 'None provided'}
                      </Typography>
                    </Paper>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <Button onClick={handleBack} sx={{ mr: 1, borderRadius: 1 }}>
                        Back
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{ borderRadius: 1 }}
                        color="success"
                      >
                        Submit
                      </Button>
                    </Box>
                  </StepContent>
                </Step>
              </Stepper>
            </MainCard>
          </Grid>

          <Grid item xs={12} md={6} sx={{ p: isMobile ? 0.5 : 1 }}>
            <MainCard
              title={
                <Box
                  display="flex"
                  flexDirection={isMobile ? 'column' : 'row'}
                  alignItems={isMobile ? 'flex-start' : 'center'}
                  justifyContent="space-between"
                  gap={1}
                >
                  <div>Recent Notes</div>
                  <DatePicker
                    label="Filter by Date"
                    value={dayjs(selectedDate)}
                    onChange={(date) =>
                      setSelectedDate(date ? dayjs(date).format('YYYY-MM-DD') : '')
                    }
                    slotProps={{
                      textField: {
                        size: 'small',
                        sx: {
                          width: isMobile ? '100%' : 180,
                          '& .MuiInputBase-root': {
                            fontSize: '0.85rem',
                            height: 36
                          },
                          '& .MuiInputLabel-root': {
                            fontSize: '0.75rem'
                          }
                        }
                      }
                    }}
                    format="DD/MM/YYYY"
                  />
                </Box>
              }
              sx={{
                p: isMobile ? 0.5 : 1,
                '& .MuiCardHeader-root': { p: 0.5 },
                '& .MuiCardContent-root': {
                  p: isMobile ? 0.5 : 1,
                  maxHeight: '70vh',
                  overflowY: 'auto',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  '&::-webkit-scrollbar': {
                    width: '0.4em'
                  },
                  '&::-webkit-scrollbar-track': {
                    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0,0,0,.1)',
                    borderRadius: '10px'
                  }
                },
                borderRadius: 2
              }}
            >
              {loading ? (
                <Typography>Loading...</Typography>
              ) : error ? (
                <Typography color="error">No Notes Found</Typography>
              ) : shiftNotes.length > 0 ? (
                shiftNotes.map((note: ShiftNote) => (
                  <Card
                    key={note.id}
                    sx={{
                      flexShrink: 0,
                      borderRadius: 2,
                      boxShadow: 2,
                      transition: 'all 0.2s',
                      '&:hover': {
                        boxShadow: `0 4px 12px ${theme.palette.grey[300]}`,
                        transform: 'translateY(-2px)'
                      },
                      bgcolor: theme.palette.background.paper,
                      borderLeft: `4px solid ${
                        note.status === 'New'
                          ? theme.palette.success.main
                          : note.status === 'Completed'
                          ? theme.palette.primary.main
                          : theme.palette.warning.main
                      }`
                    }}
                  >
                    <CardContent sx={{ p: 1.5 }}>
                      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                        <Box>
                          <Typography variant="subtitle2" fontWeight="bold" color="primary">
                            {note.title || 'Untitled'}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {note.worker_name || 'Unknown'} •{' '}
                            {note.caseNoteDate
                              ? dayjs(note.caseNoteDate).format('DD/MM/YYYY')
                              : 'N/A'}{' '}
                            • {note.caseNoteTime || 'N/A'}
                          </Typography>
                        </Box>
                        <Chip
                          label={note.status || 'Unknown'}
                          size="small"
                          color={
                            note.status === 'New'
                              ? 'success'
                              : note.status === 'Completed'
                              ? 'primary'
                              : 'warning'
                          }
                          variant="outlined"
                          sx={{ fontWeight: 'medium' }}
                        />
                      </Box>

                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, my: 1 }}>
                        {note.medicationReceived && (
                          <Chip
                            label={`Med: ${note.medicationReceived}`}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                        {note.personalCare && (
                          <Chip
                            label={`Care: ${note.personalCare}`}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                        {note.participantMood && (
                          <Chip
                            label={`Mood: ${note.participantMood}`}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                        {note.rating && (
                          <Chip
                            label={`Rating: ${note.rating}`}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                        {note.foodIntakeChartCompleted && (
                          <Chip
                            label={`Food Chart: ${note.foodIntakeChartCompleted}`}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                        {note.securityLevel && (
                          <Chip
                            label={`Security: ${note.securityLevel}`}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                        {note.assignToStaff && note.assignToStaff.length > 0 && (
                          <Chip
                            label={`Assigned: ${note.assignToStaff.join(', ')}`}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                        {note.timeTaken > 0 && (
                          <Chip
                            label={`Time: ${note.timeTaken} mins`}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                        {note.supportItemNumber && (
                          <Chip
                            label={`Support Item: ${note.supportItemNumber}`}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                        {note.goalsMet && note.goalsMet.length > 0 && (
                          <Chip
                            label={`Goals: ${note.goalsMet.join(', ')}`}
                            size="small"
                            variant="outlined"
                            color="info"
                          />
                        )}
                      </Box>

                      {(note.caseNoteDetails ||
                        note.goalsMet ||
                        note.foodProvided ||
                        note.createdBy) && (
                        <>
                          <Divider sx={{ my: 0.5 }} />
                          {note.caseNoteDetails && (
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mt: 0.5 }}>
                              <strong>Details:</strong> {note.caseNoteDetails}
                            </Typography>
                          )}
                          {note.goalsMet && note.goalsMet.length > 0 && (
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mt: 0.5 }}>
                              <strong>Goals:</strong> {note.goalsMet.join(', ')}
                            </Typography>
                          )}
                          {note.foodProvided && (
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mt: 0.5 }}>
                              <strong>Food Provided:</strong> {note.foodProvided}
                            </Typography>
                          )}
                          {note.createdBy && (
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mt: 0.5 }}>
                              <strong>Created By:</strong> {note.createdBy}
                            </Typography>
                          )}
                        </>
                      )}

                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
                        <IconButton onClick={() => handleEdit(note)} size="small" color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton onClick={() => handleDelete(note)} size="small" color="error">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </CardContent>
                  </Card>
                ))
              ) : (
                <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
                  No notes available for selected date
                </Typography>
              )}
            </MainCard>
          </Grid>

          <Dialog
            open={openDialog}
            onClose={handleDialogClose}
            fullWidth
            maxWidth="md"
            fullScreen={isMobile}
            sx={{
              '& .MuiDialogTitle-root': { p: isMobile ? 1 : 1.5, pb: 1 },
              '& .MuiDialogContent-root': { p: isMobile ? 1 : 1.5 },
              '& .MuiDialogActions-root': { p: 1 }
            }}
          >
            <DialogTitle>Edit Shift Note</DialogTitle>
            <DialogContent dividers>
              {editingNote && (
                <Grid container spacing={1.5}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Title *"
                      value={editingNote.title || ''}
                      onChange={(e) => setEditingNote({ ...editingNote, title: e.target.value })}
                      size="small"
                      variant="outlined"
                      error={!editingNote.title || editingNote.title.length > 100}
                      helperText={
                        !editingNote.title
                          ? 'Title is required'
                          : editingNote.title.length > 100
                          ? 'Title must be 100 characters or less'
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Worker"
                      value={editingNote.worker_name || ''}
                      disabled
                      size="small"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="Date *"
                      value={dayjs(editingNote.caseNoteDate)}
                      onChange={(date) =>
                        setEditingNote({
                          ...editingNote,
                          caseNoteDate: date ? dayjs(date).format('YYYY-MM-DD') : ''
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: 'small',
                          error: !editingNote.caseNoteDate,
                          helperText: !editingNote.caseNoteDate ? 'Date is required' : ''
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TimePicker
                      label="Time *"
                      value={dayjs(editingNote.caseNoteTime, 'HH:mm A')}
                      onChange={(time) =>
                        setEditingNote({
                          ...editingNote,
                          caseNoteTime: time ? dayjs(time).format('HH:mm A') : ''
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: 'small',
                          error: !editingNote.caseNoteTime,
                          helperText: !editingNote.caseNoteTime ? 'Time is required' : ''
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      error={!editingNote.assignToStaff || editingNote.assignToStaff.length === 0}
                    >
                      <InputLabel>Assign Staff *</InputLabel>
                      <Select
                        multiple
                        value={editingNote.assignToStaff || []}
                        input={<OutlinedInput label="Assign Staff *" />}
                        renderValue={(selected) => (selected as string[]).join(', ')}
                        onChange={(e) =>
                          setEditingNote({
                            ...editingNote,
                            assignToStaff: e.target.value as string[]
                          })
                        }
                      >
                        {staffMembers.map((staff) => (
                          <MenuItem key={staff?.id} value={staff?.name}>
                            <Checkbox
                              checked={(editingNote.assignToStaff || []).indexOf(staff?.name) > -1}
                              size="small"
                            />
                            <Typography variant="body2">{staff?.name}</Typography>
                          </MenuItem>
                        ))}
                      </Select>
                      {(!editingNote.assignToStaff || editingNote.assignToStaff.length === 0) && (
                        <Typography variant="caption" color="error">
                          At least one staff member must be assigned
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Support Item Number"
                      value={editingNote.supportItemNumber || ''}
                      disabled
                      size="small"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Created By"
                      value={editingNote.createdBy || ''}
                      disabled
                      size="small"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small" error={!editingNote.medicationReceived}>
                      <InputLabel>Medication *</InputLabel>
                      <Select
                        value={editingNote.medicationReceived || ''}
                        onChange={(e) =>
                          setEditingNote({
                            ...editingNote,
                            medicationReceived: e.target.value as string
                          })
                        }
                        label="Medication *"
                      >
                        {medicationOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                      {!editingNote.medicationReceived && (
                        <Typography variant="caption" color="error">
                          Medication status is required
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Food Provided"
                      value={editingNote.foodProvided || ''}
                      onChange={(e) =>
                        setEditingNote({ ...editingNote, foodProvided: e.target.value })
                      }
                      size="small"
                      error={!!(editingNote.foodProvided && editingNote.foodProvided.length > 200)}
                      helperText={
                        editingNote.foodProvided && editingNote.foodProvided.length > 200
                          ? 'Food Provided must be 200 characters or less'
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small" error={!editingNote.personalCare}>
                      <InputLabel>Personal Care *</InputLabel>
                      <Select
                        value={editingNote.personalCare || ''}
                        onChange={(e) =>
                          setEditingNote({
                            ...editingNote,
                            personalCare: e.target.value as string
                          })
                        }
                        label="Personal Care *"
                      >
                        {personalCareOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                      {!editingNote.personalCare && (
                        <Typography variant="caption" color="error">
                          Personal Care selection is required
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Food Chart</InputLabel>
                      <Select
                        value={editingNote.foodIntakeChartCompleted || ''}
                        onChange={(e) =>
                          setEditingNote({
                            ...editingNote,
                            foodIntakeChartCompleted: e.target.value as string
                          })
                        }
                        label="Food Chart"
                      >
                        {foodIntakeOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small" error={!editingNote.participantMood}>
                      <InputLabel>Mood *</InputLabel>
                      <Select
                        value={editingNote.participantMood || ''}
                        onChange={(e) =>
                          setEditingNote({
                            ...editingNote,
                            participantMood: e.target.value as string
                          })
                        }
                        label="Mood *"
                      >
                        {moodOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                      {!editingNote.participantMood && (
                        <Typography variant="caption" color="error">
                          Mood selection is required
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Time (mins)"
                      type="number"
                      value={editingNote.timeTaken || 0}
                      onChange={(e) =>
                        setEditingNote({
                          ...editingNote,
                          timeTaken: parseInt(e.target.value) || 0
                        })
                      }
                      size="small"
                      error={editingNote.timeTaken < 0 || editingNote.timeTaken > 1440}
                      helperText={
                        editingNote.timeTaken < 0
                          ? 'Time cannot be negative'
                          : editingNote.timeTaken > 1440
                          ? 'Time cannot exceed 24 hours'
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      error={!editingNote.goalsMet || editingNote.goalsMet.length === 0}
                      sx={{
                        '& .MuiInputLabel-root': {
                          fontSize: '0.875rem',
                          transform: 'translate(14px, 8px) scale(1)',
                          '&.MuiInputLabel-shrink': {
                            transform: 'translate(14px, -9px) scale(0.75)'
                          }
                        }
                      }}
                    >
                      <InputLabel>Goals Met *</InputLabel>
                      <Select
                        multiple
                        value={editingNote.goalsMet || []}
                        input={
                          <OutlinedInput
                            label="Goals Met *"
                            sx={{
                              '& .MuiSelect-select': {
                                py: 1.25,
                                fontSize: '0.875rem'
                              }
                            }}
                          />
                        }
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: 0.5,
                              fontSize: '0.875rem'
                            }}
                          >
                            {(selected as string[]).map((value) => (
                              <Chip
                                key={value}
                                label={value}
                                size="small"
                                sx={{
                                  height: 'auto',
                                  py: 0.25,
                                  '& .MuiChip-label': {
                                    fontSize: '0.75rem',
                                    padding: '0 4px'
                                  }
                                }}
                              />
                            ))}
                          </Box>
                        )}
                        onChange={(e) =>
                          setEditingNote({
                            ...editingNote,
                            goalsMet: e.target.value as string[]
                          })
                        }
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              maxHeight: 300,
                              '& .MuiMenuItem-root': {
                                py: 0.5,
                                minHeight: 'auto'
                              }
                            }
                          }
                        }}
                      >
                        {allGoalOptions.map((option) => (
                          <MenuItem
                            key={option}
                            value={option}
                            dense
                            sx={{
                              '& .MuiTypography-root': {
                                fontSize: '0.8rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                              }
                            }}
                          >
                            <Checkbox
                              checked={(editingNote.goalsMet || []).indexOf(option) > -1}
                              size="small"
                              sx={{
                                p: 0.5,
                                '& .MuiSvgIcon-root': { fontSize: '1rem' }
                              }}
                            />
                            <Box
                              component="span"
                              sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                            >
                              {option}
                            </Box>
                            <Box
                              component="span"
                              sx={{
                                fontSize: '0.7rem',
                                color: 'text.secondary',
                                flexShrink: 0
                              }}
                            >
                              {goalOptions.ShortTerm.includes(option) ? '(S)' : '(L)'}
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                      {(!editingNote.goalsMet || editingNote.goalsMet.length === 0) && (
                        <Typography
                          variant="caption"
                          color="error"
                          sx={{
                            fontSize: '0.75rem',
                            ml: '14px',
                            mt: '3px',
                            display: 'block'
                          }}
                        >
                          At least one goal must be selected
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small" error={!editingNote.rating}>
                      <InputLabel>Rating *</InputLabel>
                      <Select
                        value={editingNote.rating || ''}
                        onChange={(e) =>
                          setEditingNote({
                            ...editingNote,
                            rating: e.target.value as string
                          })
                        }
                        label="Rating *"
                      >
                        {ratingOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                      {!editingNote.rating && (
                        <Typography variant="caption" color="error">
                          Rating is required
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small" error={!editingNote.securityLevel}>
                      <InputLabel>Security Level *</InputLabel>
                      <Select
                        value={editingNote.securityLevel || ''}
                        onChange={(e) =>
                          setEditingNote({
                            ...editingNote,
                            securityLevel: e.target.value as string
                          })
                        }
                        label="Security Level *"
                      >
                        {securityLevelOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                      {!editingNote.securityLevel && (
                        <Typography variant="caption" color="error">
                          Security Level is required
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label="Details *"
                      value={editingNote.caseNoteDetails || ''}
                      onChange={(e) =>
                        setEditingNote({ ...editingNote, caseNoteDetails: e.target.value })
                      }
                      size="small"
                      error={
                        !editingNote.caseNoteDetails || editingNote.caseNoteDetails.length > 2000
                      }
                      helperText={
                        !editingNote.caseNoteDetails
                          ? 'Details are required'
                          : editingNote.caseNoteDetails.length > 2000
                          ? 'Details must be 2000 characters or less'
                          : ''
                      }
                    />
                  </Grid>
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDialogClose} size="small" variant="outlined">
                Cancel
              </Button>
              <Button
                onClick={handleDialogSave}
                color="primary"
                size="small"
                variant="contained"
                disabled={
                  !editingNote?.title ||
                  editingNote.title.length > 100 ||
                  !editingNote?.caseNoteDate ||
                  !editingNote?.caseNoteTime ||
                  !editingNote?.assignToStaff?.length ||
                  !editingNote?.medicationReceived ||
                  !editingNote?.personalCare ||
                  !editingNote?.participantMood ||
                  !editingNote?.rating ||
                  !editingNote?.securityLevel ||
                  !editingNote?.caseNoteDetails ||
                  editingNote.caseNoteDetails.length > 2000 ||
                  (editingNote.foodProvided && editingNote.foodProvided.length > 200) ||
                  (editingNote.goalsMet && editingNote.goalsMet.length === 0) || // Updated validation
                  editingNote.timeTaken < 0 ||
                  editingNote.timeTaken > 1440
                }
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      </form>
    </Box>
  );
};

export default ShiftNotes;
